import styles from "./SidebarPromotion.module.css";

interface SidebarPromotionProps {
  title: string;
  body: string;
  linkText: string;
  linkUrl: string;
}

export function SidebarPromotion({ title, body, linkText, linkUrl }: SidebarPromotionProps) {
  return (
    <div className={styles.sidebarPromotionCard}>
      <div className={styles.title}>{title}</div>
      <div className={styles.body}>{body}</div>
      <a href={linkUrl} className={styles.link}>
        {linkText}
      </a>
    </div>
  );
}
